import { useState } from 'react';
import { galleryImages } from '../../../mocks/artworks';

export default function GallerySection() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [selectedImage, setSelectedImage] = useState<typeof galleryImages[0] | null>(null);
  const categories = ['Todos', 'Abstracto', 'Contemporáneo', 'Naturaleza', 'Minimalista'];

  const filteredImages = selectedCategory === 'Todos' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <section id="gallery" className="py-24 bg-[#FFF8E7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-[#e8a65b] rounded-full"></div>
            <span className="text-xs uppercase tracking-widest text-gray-600 font-medium">
              Galería de Arte
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Obras <span className="text-[#e8a65b]">Destacadas</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Explora una selección de mis trabajos más recientes y representativos
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-[#e8a65b] text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              onClick={() => setSelectedImage(image)}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-96">
                <img
                  src={image.image}
                  alt={image.title}
                  className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-serif text-white mb-2">{image.title}</h3>
                  <span className="inline-block px-3 py-1 bg-[#e8a65b] text-white text-xs rounded-full">
                    {image.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div 
            className="relative max-w-6xl w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="max-w-full max-h-[85vh] object-contain"
            />
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-black/80 backdrop-blur-sm px-6 py-4 rounded-full">
              <h3 className="text-xl font-serif text-white mb-1 text-center">{selectedImage.title}</h3>
              <span className="inline-block px-3 py-1 bg-[#e8a65b] text-white text-xs rounded-full">
                {selectedImage.category}
              </span>
            </div>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white rounded-full text-gray-900 hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}